import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, { class: "py-2 px-4 border rounded-sm font-medium whitespace-nowrap inline-flex items-center text-gray-800 border-gray-300 bg-gray-100 hover:bg-gray-200 dark:text-white dark:border-gray-600 dark:bg-gray-700 dark:hover:bg-gray-600" }), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}